import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ConfigService } from '@speedy/core';
import { Rating, Review } from '../interfaces/Review';

export interface ReviewFormData {
  title: string | null;
  detail: string | null;
  nickname: string | null;
  ratings: Partial<{ rating_name: string | null; value: string | null }>[];
  review_entity: string | null;
  review_status: string | null;
  entity_pk_value: null;
}

@Injectable({ providedIn: 'root' })
export class ReviewsService {
  constructor(
    protected http: HttpClient,
    protected configService: ConfigService,
  ) {}

  getReviews(sku: string) {
    return this.http.get<Review[]>(
      `${this.configService.getApiUrl()}products/${sku}/reviews`,
    );
  }

  addReview(review: ReviewFormData) {
    return this.http.post(`${this.configService.getApiUrl()}reviews`, { review });
  }

  getRatings(storeId: number) {
    return this.http.get<Rating[]>(
      `${this.configService.getApiUrl()}getratings/${storeId}`,
    );
  }
}
